import { Label } from "@mui/icons-material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState, useLayoutEffect } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import ReactSelect from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import Tooltip from "components/Tooltip/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import { RemoveRedEye } from "@mui/icons-material";
import useDebounce from "hooks/useDebounce";
import useDragDropforTestimonials from "hooks/useDragDropforTestimonials";

import EditIcon from "@mui/icons-material/Edit";
import {
  getCityWiseSections,
  getCityDropdown,
  cityWiseSectionDisplayOrder,
  cityWiseSectionDelete,
  getLiveLectureCourses,
  getCityWiseTestimonials,
  mapTestimonials,
} from "services/citypages";
import UpdateCityWiseSection from "../CityWiseCenters/Sections/UpdateCityWiseSection";
import AddCityWiseSection from "../CityWiseCenters/Sections/AddCityWiseSection";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function MapCitytestimonial() {
  const [record, setRecord] = useState([{}]);
  const [activePage, setActivePage] = useState(1);
  const [state, setState] = useState([[], []]);
  const { cityid, stateId } = useParams();

  const [search, setSearch] = useState();
  const [addModal, setAddModal] = useState(false);
  const [DragDrop] = useDragDropforTestimonials(state, setState, (newState) => {
    // Collect mapped testimonials (2nd column, i.e. state[1])
    const mappedTestimonials = newState[1];

    // Prepare payload
    const payload = {
      cityid: selectedCity?.value || cityid,
      stateid: selectedStateID || stateId,
      testimonials: mappedTestimonials.map((t) => ({
        testimonialid: t.id,
        studentname: t.label,
        rank: t.rank,
        year: t.year,
        image: t.image,
      })),
    };

    // 👇 call your API
    mapTestimonial(payload);
  });



  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [flag, setFlag] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [data, setData] = useState({});
  const [updateModal, setUpdateModal] = useState(false);
  const [descModal, setDescModal] = useState(false);
  const [descContent, setDescContent] = useState("");
  const debounceValue = useDebounce(search || "", 300);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [editOrderId, setEditOrderId] = useState(null);
  const [selectedData, setSelectedData] = useState({});
  const navigate = useNavigate();

  const [selectedId, setSelectedId] = useState("");
  const [selectedStateID, setSelectedStateID] = useState("");

  //   ****************************************************** Fetch Roles **********************************************************
  const fetchRoles = async () => {
    try {
      showLoader();
      const res = await getCityDropdown();
      hideLoader();
      if (res.code === 200) {
        setAllRoles(res.data.citywisecenters || []);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    fetchRoles();
  }, []);

  //   ************************************ Fetch Records ***********************************************
  //   ************************************ Fetch Records ***********************************************
  const handleRecords = async (
    page = activePage,
    searchText = debounceValue,
    cityId = selectedCity?.value || cityid
  ) => {
    try {
      showLoader();
      if (cityId) {
        const res = await getCityWiseTestimonials({
          page,
          search: searchText,
          cityid: cityId,
        });
        hideLoader();
        if (res.code === 200) {
          const { testimonials = [] } = res.data;
          setSelectedStateID(res.data?.stateid)

          const unmapped = testimonials
            .filter((t) => !t.mappedtestimonial)
            .map((t) => ({
              id: String(t.testimonialid), // draggableId must be string
              name: t.studentname,
              image: t.studentimage,
              rank: t.rank,
              year: t.yearofstudy,
            }));

          const mapped = testimonials
            .filter((t) => t.mappedtestimonial)
            .map((t) => ({
              id: String(t.testimonialid),
              name: t.studentname,
              image: t.studentimage,
              rank: t.rank,
              year: t.yearofstudy,
            }));

          setState([unmapped, mapped]);
          setTotal(testimonials.length || 0);
          setFlag(true);
        }
        else {
          toast.error(res.message);
          setFlag(false);
        }
      } else {
        toast.error("City Selection is mandatory");
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  const handleback = () => {
    navigate(-1)
  };

  // Auto-fetch if params exist
  useEffect(() => {
    if (cityid) {
      setActivePage(1);
      handleRecords(1, debounceValue, cityid);
      setFlag(true); // so DragDrop section shows
    }
  }, [cityid, stateId]);

  // ⬇️ After fetchRoles loads cities, auto-select if cityid is present in params
  useEffect(() => {
    if (cityid && allRoles.length > 0) {
      const matched = allRoles.find((c) => String(c.id) === String(cityid));
      if (matched) {
        setSelectedCity({ value: matched.id, label: matched.city });
      }
    }
  }, [cityid, allRoles]);



  useEffect(() => {
    if (flag) {
      handleRecords();
    }
  }, [activePage, limit]);

  // const restFilter = () => {
  //   setSearch("");
  //   setSelectedId(null);
  //   setData((prev) => ({ ...prev, moduleName: null }));
  //   setRecord([]);
  //   setTotal(0);
  //   setSelectedCity(null)
  //   setFlag(false)
  // };

  const mapTestimonial = async (payload) => {
    try {
      const res = await mapTestimonials(payload)
      if (res.code === 200) {
        toast.success("Testimonial mapped successfully!")
      } else {
        toast.error("Something went error")
      }
    } catch (err) {
      console.error("❌ Error saving testimonials", err);
    }
  };


  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <form className="" style={{ width: "50%" }}>
                <div className="row w-100 ">
                  <div className={`col-form-label py-0 col-sm-9`}></div>

                  <div className="col-sm-3 "></div>
                </div>
              </form>
              <h4 className="Title">
                <Link onClick={handleback}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                Map Testimonials to City
              </h4>
            </div>
            <div className="mt-3">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <div style={{ width: "300px" }}>
                  <ReactSelect
                    value={selectedCity}   // ✅ bind to selectedCity
                    onChange={(e) => setSelectedCity(e)}
                    options={allRoles.map((city) => ({
                      value: city.id,
                      label: city.city,
                    }))}
                    className="react-select w-100"
                    placeholder="Select City"
                  />

                </div>

                <Button
                  type="submit"
                  onClick={() => {
                    setActivePage(1);
                    handleRecords();
                  }}
                >
                  Search
                </Button>

                {/* <Button className="refresh_btnn" onClick={restFilter}>
                  <i className="fa fa-refresh"></i>
                </Button> */}
              </div>
            </div>

            {flag ? (
              (state[0]?.length > 0 || state[1]?.length > 0) ? (
                <div className="row my-4">
                  <DragDrop />
                </div>
              ) : (
                <div>
                  <br /> <br />
                  <h5 className="w-100 text-center">No Testimonials Available</h5>
                </div>
              )
            ) : null}

            {flag && total > limit ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(page) => setActivePage(page)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>


    </>
  );
}
